import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';

import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
//import DeleteIcon from '@mui/icons-material/Delete';
//import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
//import { Button, Spin } from 'antd';
import { fetchDataActive, fetchData, postData, updateData, fetchData1, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save'; // Example for Material UI icon
import RefreshIcon from '@mui/icons-material/Refresh';
//import '../../styles.css';
function GenerateFees() {
    const [isLoading, setIsLoading] = useState(false);
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [deleteManufacture, setDeleteManufacture] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData1, setFilteredData1] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, clubId, branchId, userId, permissions, logout, token } = useAuth();
    const [successMessage, setSuccessMessage] = useState("");
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);

    //Create Constants---------------------
    const [isSubmit, setIsSubmit] = useState(false);
    const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
    const [feesdescription, setFeesDescription] = useState("");
    const [feesamount, setFeesAmount] = useState("");
    const [type, setFeesType] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [fromDate1, setFromDate1] = useState("");
    const [toDate1, setToDate1] = useState("");

    const [isonetime, setIsOneTime] = useState(true);
    const [ismonthly, setIsMonthly] = useState(false);
    const [selectedValue, setSelectedValue] = useState(1);
    //-------------------------------------------for edit-------------------
    const [isModalOpenEdit, setIsModalOpenEdit] = useState(false); // For editing
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState(null); // Holds the person data when editing
    const [selectedfees, setselectedfees] = useState("");
    const [feeslist, setFeesOptions] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
        // fetchtableData1();
        fetchFees();
        // inputRef.current.focus();
    }, [isAuthenticated, clubId, token, logout]);

    useEffect(() => {
        console.log("From Date Changed:", fromDate);
        console.log("To Date Changed:", toDate);
    }, [fromDate, toDate]);

    const fetchtableData = async () => {

        fetchData1('ClubFeesApi', `/tmpType/${clubId}/${branchId}/${2}`, token)

            .then((response) => {
                if (response.responseCode === '1111') {

                    // const options = response.response_data.map(fees => ({
                    //     value: fees.id,
                    //     label: fees.feesdescription,
                    //     amount: fees.amount, // Storing fee amount in the option object
                    //     type: fees.feesRecuringType
                    // }));

                    // setData(options);
                    setFilteredData1(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Persons Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };
    const formatDateForInput = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is undefined or null
        const currentDate = new Date(dateString);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const fetchtableData1 = async () => {

        fetchData1('ClubFeesApi', `/tmpType/${clubId}/${branchId}/${1}`, token)

            .then((response) => {
                if (response.responseCode === '1111') {

                    const options = response.response_data.map(fees => ({
                        value: fees.feesId,
                        label: fees.description,
                        amount: fees.amount, // Storing fee amount in the option object
                        type: fees.feesRecuringType
                    }));

                    setData(options);
                    setFilteredData1(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Persons Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };
    const fetchFees = async () => {
        try {
            // const response = await fetchData('ClubFeesApi', `/${clubId}`, token)
            const response = await fetchData1('ClubFeesApi', `/c/${clubId}/${branchId}/${1}`, token)
            if (response.responseCode === '1111') {

                const options = response.response_data.map(fees => ({
                    value: fees.id,
                    label: fees.feesDescription,
                    type: fees.feesRecuringType,
                    amount: fees.feesAmount,

                }));
                setFeesOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };



    const openConfirmDialog = (manuId) => {
        setDeleteManufacture(manuId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteManufacture(null);
        setConfirmDialogOpen(false);
    };


    //Create Section----------------------
    const handleFormSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
    }

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === "fromDate") {
            setFromDate(value);
        } else if (name === "toDate") {
            setToDate(value);
        }
    };




    const toggleModalCreate = () => {
        if (!isProcessing) {
            setIsModalOpenCreate(prev => !prev);
        }

    };
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };


    //Edit-------------------------

    const toggleModalEdit = () => {
        setIsModalOpenEdit(prev => !prev);
        if (isModalOpenEdit) {
            resetForm(); // Only reset when modal is closing, not opening
            setEditData(null);
            setIsEditing(false);
        }
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = String(date.getFullYear()).slice(-2); // Get last 2 digits of year
        return `${day}-${month}-${year}`;
    };
    // Reset form fields
    const resetForm = () => {
        setFeesDescription('');
        setFeesAmount('');
        setFromDate('');
        setToDate('');
        setSelectedValue('1');
        setIsOneTime(false);
        setIsMonthly(true)
    };

    useEffect(() => {
        if (selectedfees) {
            let fromDate = new Date();
            let toDate = new Date();

            if (selectedfees.type == 1) {
                // Monthly: First to last day of the current month
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1);
                toDate = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 0);
            } else if (selectedfees.type == 2) {
                // Quarterly: First to last day of the current quarter
                const currentMonth = fromDate.getMonth();
                const quarterStartMonth = currentMonth - (currentMonth % 3);
                const quarterEndMonth = quarterStartMonth + 2;

                fromDate = new Date(fromDate.getFullYear(), quarterStartMonth, 1);
                toDate = new Date(fromDate.getFullYear(), quarterEndMonth + 1, 0);
            } else if (selectedfees.type == 3) {
                // Half-Yearly: First to last day of the current half-year
                const currentMonth = fromDate.getMonth();
                const halfYearStartMonth = currentMonth < 6 ? 0 : 6;
                const halfYearEndMonth = halfYearStartMonth + 5;

                fromDate = new Date(fromDate.getFullYear(), halfYearStartMonth, 1);
                toDate = new Date(fromDate.getFullYear(), halfYearEndMonth + 1, 0);
            } else if (selectedfees.type == 4) {
                // Financial Year: July 1 to June 30
                const currentMonth = fromDate.getMonth(); // 0-based (May is 4)
                const currentYear = fromDate.getFullYear();

                if (currentMonth >= 6) {
                    // If current month is July (6) or later, start date is July 1 of current year
                    fromDate = new Date(currentYear, 6, 1); // July 1
                    toDate = new Date(currentYear + 1, 5, 30); // June 30 next year
                } else {
                    // If current month is before July, start date is July 1 of previous year
                    fromDate = new Date(currentYear - 1, 6, 1); // July 1 last year
                    toDate = new Date(currentYear, 5, 30); // June 30 this year
                }
            }

            // Format dates as "DD-MM-YYYY"
            const formatDate = (date) => {
                return date.toLocaleDateString("en-GB").split('/').reverse().join('-');
            };

            setFromDate(formatDate(fromDate));
            setToDate(formatDate(toDate));
        }
    }, [selectedfees]);

    const formatDateOnly = (dateStr) => {
        return new Date(dateStr).toISOString().split('T')[0];
    };


    const GenerateData = async () => {
        if (!selectedfees || !fromDate || !toDate) {
            alert('Please select fee type and date range before generating.');
            return;
        }

        setIsProcessing(true);
        try {
            const response = await fetchData1(
                'ClubFeesApi',
                `/${clubId}/${branchId}/${selectedfees.value}/${fromDate}/${toDate}`,
                token
            );

            await new Promise(resolve => setTimeout(resolve, 2000)); // optional delay
            alert(response.responseMessage);

        } catch (error) {
            if (error.response) {
                console.error('Server Error:', error.response.data);
                alert('Server error. Please try again later.');
            } else if (error.request) {
                console.error('No response received:', error.request);
                alert('No server response. Check your network.');
            } else {
                console.error('Unexpected Error:', error.message);
                alert('Unexpected error occurred.');
            }
        } finally {
            setIsProcessing(false);
        }
    };

    const handleFeesChange = (selectedOption) => {
        setselectedfees(selectedOption);
        setFeesAmount(selectedOption ? selectedOption.amount : ""); // Set amount
        setFeesType(selectedOption ? selectedOption.type : ""); // Set type
    };

    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = filteredData1.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('PurchaseOrderDate');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const sortedData = stableSort(filteredData, getComparator(order, orderBy));

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>
            <div className='w-full mb-4 flex'>

                <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}> GENERATE FEES</h6>
                <input
                    className="shadow text-gray-700 leading-tight"
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? '250px' : '140px',
                        height: '30px',
                        border: '1px solid #ccc',
                        borderRadius: '15px',
                        padding: '0 20px',
                        transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                        outline: 'none',
                        borderColor: isFocused ? 'darkcyan' : '#ccc',
                        boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        marginLeft: '10px'
                    }}
                />
                <div className="flex items-center space-x-2">
                    <label htmlFor="dateofbirth" className="whitespace-nowrap">From</label>
                    <input
                        className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        value={fromDate1}
                        onChange={(e) => setFromDate1(e.target.value)}
                        type="date"
                        placeholder="Select From Date"
                    />
                </div>

                <div className="flex items-center space-x-2">
                    <label htmlFor="dateofbirth" className="whitespace-nowrap">To</label>
                    <input
                        className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        value={toDate1}
                        onChange={(e) => setToDate1(e.target.value)}
                        type="date"
                        placeholder="Select To Date"
                    />
                </div>

                <Button
                    // style={{ marginLeft: '8px', color: 'darkgreen' }}
                    style={{
                        background: 'linear-gradient(to right, #A8A196,#A8A196)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        //marginLeft: '5px',
                        marginLeft: '15px',
                        marginTop: '0.2%'

                    }}
                    onClick={handleFormSubmit}

                >
                    <RefreshIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>{isLoading ? <CircularProgress size={16} color="inherit" /> : "Refresh"}</b>
                </Button>



                <div className="button-container-1" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Tooltip
                        title="Generate Subscription Fee"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: 'darkolivegreen',
                                    color: 'white',
                                    border: '1px solid white',
                                    fontWeight: 'bolder',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                    maxHeight: '30px',
                                    marginTop: '0.2%'
                                },
                            },
                        }}
                    >
                        <Button
                            component={Link}
                            onClick={toggleModalCreate}
                            className="linkcolor"
                            style={{ color: 'whitesmoke', fontWeight: 'bolder', backgroundColor: '#A888B5', height: '30px', marginLeft: '5px' }}
                        >
                            <AddToQueueIcon />
                        </Button>
                    </Tooltip>

                    <Tooltip
                        title="Create CLUB FESS"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#0e728c',
                                    color: 'white',
                                    border: '1px solid white',
                                    fontWeight: 'bold',
                                    boxShadow: 2,
                                },
                            },
                        }}
                    >
                    </Tooltip>
                </div>
            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', marginTop: '0.50%' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#243642', width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                {['Sl.No', 'Party', 'Email', 'Fees Description', 'Bill Date', 'Amount', 'Paid Amount', 'Balance Amount'].map((column, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{
                                            borderBottom: '1px solid #F5F5F5',
                                            fontSize: '12px',
                                            padding: '7px',
                                            color: 'darkblue',
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase',
                                        }}
                                    >
                                        <TableSortLabel
                                            active={orderBy === column}
                                            direction={orderBy === column ? order : 'asc'}
                                            onClick={(e) => handleRequestSort(e, column)}
                                        >
                                            {column}
                                        </TableSortLabel>
                                    </TableCell>
                                ))}
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                            {sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={'highlighted-row'}
                                    sx={{
                                        padding: '5px',
                                        //backgroundColor: data.IsVerified === false ? '#F1D3CE' : 'transparent'
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px', width: '1%' }}>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px', width: '20%' }}>
                                        {data.party}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px', width: '15%' }}>
                                        {data.email}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px', width: '25%' }}>
                                        {data.description}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'left', fontSize: '14px', width: '5%' }}>
                                        {formatDate(data.billDate)}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'center', fontSize: '14px' }}>
                                        {data.amount ? data.amount.toFixed(2) : "0.00"}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'center', fontSize: '14px' }}>
                                        {data.paidAmount ? data.paidAmount.toFixed(2) : "0.00"}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #D4E2D4', color: 'black', padding: '3px', textAlign: 'center', fontSize: '14px' }}>
                                        {data.balanceAmount ? data.balanceAmount.toFixed(2) : "0.00"}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100, 150]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                    '& .MuiTablePagination-toolbar': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        minHeight: '40px',
                    },
                    '& .MuiTablePagination-selectLabel': {
                        marginBottom: 0,
                    },
                    '& .MuiTablePagination-displayedRows': {
                        marginBottom: 0,
                    },
                }}
            />


            {isModalOpenCreate && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '60%' }}>
                        <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> GENERATE FEES</h6>

                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label htmlFor="fees" className="text-sm font-medium"> Fees </label>
                                <Select
                                    value={selectedfees}
                                    onChange={handleFeesChange}
                                    options={feeslist}
                                    placeholder="Select Fees"
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                        control: (base) => ({
                                            ...base,
                                            width: '100%',
                                            minHeight: '38px',
                                            border: '1px solid #D1D5DB',
                                            borderRadius: '6px',
                                            padding: '2px 3px',
                                            fontSize: '14px'
                                        })
                                    }}
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label htmlFor="feesAmount">Fees Type</label>


                                <select
                                    name="type"
                                    value={type}
                                    className="form-select block">
                                    <option value="">Select</option>
                                    <option value="1">Monthly</option>
                                    <option value="2">Quarterly</option>
                                    <option value="3">Half Yearly</option>
                                    <option value="4">Yearly</option>
                                    <option value="0">One Time</option>

                                </select>

                            </div>
                            <div className="w-1/4 mr-2">
                                <label htmlFor="feesAmount">Fees Amount</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    value={feesamount}
                                    onChange={(e) => setFeesAmount(e.target.value)} // Allow manual changes if needed
                                    type="text"
                                    placeholder="Enter Fees Amount"
                                    readOnly // Make it readonly if users shouldn't modify it
                                />
                            </div>
                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/4 mr-2">
                                <label htmlFor="code">From Date
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 focus:ring-cyan-500"
                                    name="fromDate"
                                    value={fromDate}
                                    onChange={handleDateChange}
                                    type="date"
                                />
                            </div>


                            <div className="w-1/4 mr-2">
                                <label htmlFor="code">To Date
                                    <span className="text-red-500 ml-1">*</span>
                                </label>
                                <input
                                    className="border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 focus:ring-cyan-500"
                                    name="toDate"
                                    value={toDate}
                                    onChange={handleDateChange}
                                    type="date"
                                />
                            </div>




                        </div>


                        {/* Action Buttons */}
                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                            <Button
                                onClick={GenerateData}
                                disabled={isProcessing}
                                variant="contained"
                                style={{
                                    color: 'white',
                                    fontWeight: 'bolder',
                                    backgroundColor: '#5DB996',
                                }}
                            >
                                {isProcessing ? (
                                    <CircularProgress size={20} style={{ color: 'white' }} />
                                ) : (
                                    'GENERATE'
                                )}
                            </Button>

                            <Button
                                onClick={toggleModalCreate}
                                disabled={isProcessing}
                                variant="contained"
                                style={{
                                    color: 'white',
                                    fontWeight: 'bolder',
                                    backgroundColor: '#FF748B',
                                    marginLeft: '5px',
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            )
            }



        </div>

    );
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}



export default GenerateFees;




